export const SET_CLIENT = 'CLIENT/SET_CLIENT';
export const SET_ADMIN_PASSWORD_IS_VALID = 'CLIENT/SET_ADMIN_PASSWORD_IS_VALID';
export const SET_MODAL_ADMIN_PASSWORD = 'CLIENT/SET_MODAL_ADMIN_PASSWORD';
export const SET_USERS_CLIENT = 'CLIENT/SET_USERS_CLIENT';
export const SET_CURRENT_USER = 'CLIENT/SET_CURRENT_USER';
